// extracted by mini-css-extract-plugin
export default {"editorContainer":"TextEditor_editorContainer__BOHEk","EditorMain":"TextEditor_EditorMain__wGksW"};